import { Box, Button, Input, Typography, Sheet } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { supabase } from '../../supabaseClient';

const ClientLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleLogin = async () => {
    setErrorMsg('');
    const { data: authData, error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setErrorMsg(error.message);
      return;
    }

    const userId = authData?.user?.id;
    if (!userId) {
      setErrorMsg('Login failed: user not found.');
      return;
    }

    // Query the users table by id for user_type (no role or email query)
    const { data: profile, error: profileError } = await supabase
      .from('users')
      .select('user_type')
      .eq('id', userId)
      .single();

    if (profileError) {
      setErrorMsg('Unable to retrieve user profile.');
      return;
    }

    if (profile?.user_type === 'client' || profile?.user_type === 'super-admin') {
      navigate('/client/home');
    } else {
      setErrorMsg('You do not have access to the client portal.');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        minHeight: '100vh',
        bgcolor: 'background.body',
        px: 2,
        py: 4,
        textAlign: 'center',
      }}
    >
      <Sheet
        variant="outlined"
        sx={{
          maxWidth: 400,
          width: '100%',
          p: 4,
          borderRadius: 'md',
          boxShadow: 'md',
          mx: 'auto',
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <img
            src="/fldp_final_color.png"
            alt="FLDP Logo"
            style={{ maxWidth: '160px', marginBottom: '1rem', display: 'block', marginInline: 'auto' }}
          />
          <Typography level="h4">FLDP Client Portal</Typography>
        </Box>
        <Input
          placeholder="Email"
          type="email"
          fullWidth
          sx={{ mb: 2 }}
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <Input
          placeholder="Password"
          type="password"
          fullWidth
          sx={{ mb: 2 }}
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        {errorMsg && (
          <Typography color="danger" level="body-sm" sx={{ mb: 1 }}>
            {errorMsg}
          </Typography>
        )}
        <Button fullWidth onClick={handleLogin}>
          Login
        </Button>
      </Sheet>

      <Box sx={{ maxWidth: 600, mt: 4 }}>
        <Typography level="body-xs" fontSize="xs" color="neutral">
          <strong>Liability Disclaimer</strong><br />
          Electronic data provided herein is presented for informational purposes only. Florida Land Design &amp; Permitting (FLD&amp;P) provides no warranty either expressed or implied about the reliability, accuracy, completeness, and/or timeliness of these electronic files. The recipient assumes responsibility and accepts all conditions under which the data is provided. FLD&amp;P shall not be liable for any misuse and may revise, edit and enhance any electronic data without prior notice and shall assume no responsibility for nondisclosure of any changes. This material shall not be used by any third party without prior authorization. Files provided are intended to be free of any viruses, nevertheless, FLD&amp;P accepts no responsibility for any contamination or damage as a result of data use.
        </Typography>
      </Box>
    </Box>
  );
};

export default ClientLogin;